import React from 'react'
import { Deal } from '../models/shared/Deal'
import { useOrganization } from '../context/OrganizationContext'
import { Button, ButtonGroup, FormSelect, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { calculateTimePerStep } from '../utils/shared/calculations'
import { textApplyVariables, useText } from '../context/TextContext'
import { useSaveToast } from '../context/SaveToastContext'

interface Props {
    upToDateDeal: Deal
    deal: Deal
    onDealStepUpdate: (stepId: string) => Promise<void>
    className?: string
}

interface FormatTimeOptions {
    full?: boolean
    minimal?: boolean
}
export default function DealSteps(props: Props) {
    const { organization } = useOrganization();
    const text = useText();
    const { markSaved, startSaving } = useSaveToast();

    const allSteps = organization.dealSteps || [];
    const currentStepIx = allSteps.findIndex(step => step.id === props.deal.stepId);
    const timeSpendPerStep = calculateTimePerStep(props.upToDateDeal, allSteps);

    const handleStepChange = async (stepId: string) => {
        const id = startSaving();
        await props.onDealStepUpdate(stepId);
        markSaved(id);
    }

    const formatTime = (stepId: string, options: FormatTimeOptions = {}) => {
        let empty = options.minimal ? '' : text.hasNotBeenHere;
        let time = options.full ? empty : `0 ${text.days}`;
        const record = timeSpendPerStep[stepId];
        if (!record) {
            return time;
        }

        if (record.days > 0) {
            time = `${record.days} ${record.days > 1 ? text.days : text.day}`;
        } else if (record.hours > 0) {
            time = `${record.hours} ${record.hours > 1 ? text.hours : text.hour}`;
        } else if (record.minutes > 0) {
            time = `${record.minutes} ${record.minutes > 1 ? text.minutes : text.minute}`;
        } else if (record.seconds > 0) {
            time = `${record.seconds} ${record.seconds > 1 ? text.seconds : text.second}`;
        }

        if ((options.full || options.minimal) && record.secondsTotal < 5) {
            return empty;
        }

        if (options.minimal) {
            return `(${time})`;
        } else if (options.full) {
            return textApplyVariables(text.beenHere, { time });
        }
        return time;
    }

    return (
        <div className={`${props.className}`}>
            <ButtonGroup className='w-100 d-none d-lg-flex flex-wrap'>
                {allSteps.map((step, index) => <OverlayTrigger placement='bottom' key={step.id} overlay={<Tooltip>
                    <div className='d-flex flex-column align-items-start'>
                        <div>{step.name}</div>
                        <div className='small'>{formatTime(step.id, { full: true })}</div>
                    </div>
                </Tooltip>}>
                    <Button key={step.id} variant={currentStepIx >= index ? 'secondary' : 'outline-secondary'}
                        onClick={() => handleStepChange(step.id)}>
                        {formatTime(step.id)}
                    </Button>
                </OverlayTrigger>
                )}
            </ButtonGroup>

            <FormSelect className="d-lg-none" value={props.deal.stepId} onChange={(e) => handleStepChange(e.target.value)}>
                {allSteps.map(step => {
                    return <option key={step.id} value={step.id}>{step.name} {formatTime(step.id, { minimal: true })}</option>
                })}
            </FormSelect>
        </div>
    )
}
